exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mibox[data-v-2e8a2339]{bottom:0;right:5px;opacity:1;transition:opacity .5s ease 0s;box-sizing:border-box;direction:ltr;position:fixed!important;z-index:16000160!important}@media (min-width:768px){.mibox[data-v-2e8a2339]{bottom:20px;right:30px}}.whatsapp[data-v-2e8a2339]{width:20%;height:20%;fill:#26d266;stroke:none;float:right;transition:transform .2s}.whatsapp[data-v-2e8a2339]:hover{transform:scale(1.5)}", ""]);

// exports
